import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";

export function MiBadge({
  backgroundColor,
  color,
  borderColor,
  icon,
  iconColor,
  text,
  className,
  fontSize = 14,
  iconSize = 0.8,
  rounded = false,
  ...rest
}: Readonly<MiBadgeProps>) {
  const { classes } = useStyles({
    backgroundColor,
    color,
    borderColor,
    rounded,
  });

  return (
    <Box className={`${classes.badge} ${className ?? ""}`} {...rest}>
      {icon && <MiIcon path={icon} color={iconColor} size={iconSize} />}
      <Typography fontSize={fontSize}>{text}</Typography>
    </Box>
  );
}

const useStyles = makeStyles<MiBadgeProps>()(
  (
    theme,
    {
      backgroundColor = theme.palette.grey[300],
      color = theme.palette.common.white,
      borderColor,
      rounded,
    }
  ) => ({
    badge: {
      backgroundColor,
      color,
      border: `1px solid ${borderColor ?? color}`,
      padding: theme.spacing(0.5, 1),
      borderRadius: rounded ? "100%" : 4,
      display: "flex",
      width: "fit-content",
      gap: 2,
    },
  })
);

export interface MiBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  icon?: string;
  iconColor?: string;
  text?: string | number;
  fontSize?: number | string;
  iconSize?: number;
  rounded?: boolean;
}
